export const NIGERIAN_INSTITUTIONS = [
  // ─── Federal Universities ───────────────────────────────────────────────────
  { name: "Abubakar Tafawa Balewa University, Bauchi", city: "Bauchi", type: "Federal University" },
  { name: "Ahmadu Bello University, Zaria", city: "Zaria", type: "Federal University" },
  { name: "Bayero University, Kano", city: "Kano", type: "Federal University" },
  { name: "Federal University of Agriculture, Abeokuta", city: "Abeokuta", type: "Federal University" },
  { name: "Federal University of Agriculture, Makurdi", city: "Makurdi", type: "Federal University" },
  { name: "Federal University of Petroleum Resources, Effurun", city: "Effurun", type: "Federal University" },
  { name: "Federal University of Technology, Akure", city: "Akure", type: "Federal University" },
  { name: "Federal University of Technology, Minna", city: "Minna", type: "Federal University" },
  { name: "Federal University of Technology, Owerri", city: "Owerri", type: "Federal University" },
  { name: "Federal University, Birnin Kebbi", city: "Birnin Kebbi", type: "Federal University" },
  { name: "Federal University, Dustin-Ma", city: "Dustin-Ma", type: "Federal University" },
  { name: "Federal University, Gashua", city: "Gashua", type: "Federal University" },
  { name: "Federal University, Gusau", city: "Gusau", type: "Federal University" },
  { name: "Federal University, Kashere", city: "Kashere", type: "Federal University" },
  { name: "Federal University, Lafia", city: "Lafia", type: "Federal University" },
  { name: "Federal University, Lokoja", city: "Lokoja", type: "Federal University" },
  { name: "Federal University, Ndufu-Alike", city: "Ndufu-Alike", type: "Federal University" },
  { name: "Federal University, Otuoke", city: "Otuoke", type: "Federal University" },
  { name: "Federal University, Oye-Ekiti", city: "Oye-Ekiti", type: "Federal University" },
  { name: "Federal University, Wukari", city: "Wukari", type: "Federal University" },
  { name: "Michael Okpara University of Agriculture, Umudike", city: "Umudike", type: "Federal University" },
  { name: "Modibbo Adama University, Yola", city: "Yola", type: "Federal University" },
  { name: "National Open University of Nigeria, Abuja", city: "Abuja", type: "Federal University" },
  { name: "Nigerian Defence Academy, Kaduna", city: "Kaduna", type: "Federal University" },
  { name: "Nnamdi Azikiwe University, Awka", city: "Awka", type: "Federal University" },
  { name: "Obafemi Awolowo University, Ile-Ife", city: "Ile-Ife", type: "Federal University" },
  { name: "University of Abuja", city: "Abuja", type: "Federal University" },
  { name: "University of Benin, Benin City", city: "Benin City", type: "Federal University" },
  { name: "University of Calabar", city: "Calabar", type: "Federal University" },
  { name: "University of Ibadan", city: "Ibadan", type: "Federal University" },
  { name: "University of Ilorin", city: "Ilorin", type: "Federal University" },
  { name: "University of Jos", city: "Jos", type: "Federal University" },
  { name: "University of Lagos", city: "Lagos", type: "Federal University" },
  { name: "University of Maiduguri", city: "Maiduguri", type: "Federal University" },
  { name: "University of Nigeria, Nsukka", city: "Nsukka", type: "Federal University" },
  { name: "University of Port Harcourt", city: "Port Harcourt", type: "Federal University" },
  { name: "University of Uyo", city: "Uyo", type: "Federal University" },
  { name: "Usmanu Danfodiyo University, Sokoto", city: "Sokoto", type: "Federal University" },

  // ─── State Universities ─────────────────────────────────────────────────────
  { name: "Abia State University, Uturu", city: "Uturu", type: "State University" },
  { name: "Adamawa State University, Mubi", city: "Mubi", type: "State University" },
  { name: "Adekunle Ajasin University, Akungba-Akoko", city: "Akungba-Akoko", type: "State University" },
  { name: "Akwa Ibom State University, Ikot Akpaden", city: "Ikot Akpaden", type: "State University" },
  { name: "Ambrose Alli University, Ekpoma", city: "Ekpoma", type: "State University" },
  { name: "Anambra State University, Uli", city: "Uli", type: "State University" },
  { name: "Bauchi State University, Gadau", city: "Gadau", type: "State University" },
  { name: "Benue State University, Makurdi", city: "Makurdi", type: "State University" },
  { name: "Borno State University, Maiduguri", city: "Maiduguri", type: "State University" },
  { name: "Cross River State University of Technology, Calabar", city: "Calabar", type: "State University" },
  { name: "Delta State University, Abraka", city: "Abraka", type: "State University" },
  { name: "Ebonyi State University, Abakaliki", city: "Abakaliki", type: "State University" },
  { name: "Ekiti State University, Ado Ekiti", city: "Ado Ekiti", type: "State University" },
  { name: "Enugu State University of Science & Technology, Enugu", city: "Enugu", type: "State University" },
  { name: "Gombe State University, Gombe", city: "Gombe", type: "State University" },
  { name: "Ibrahim Badamasi Babangida University, Lapai", city: "Lapai", type: "State University" },
  { name: "Ignatius Ajuru University of Education, Port Harcourt", city: "Port Harcourt", type: "State University" },
  { name: "Imo State University, Owerri", city: "Owerri", type: "State University" },
  { name: "Jigawa State University, Kafin Hausa", city: "Kafin Hausa", type: "State University" },
  { name: "Kaduna State University, Kaduna", city: "Kaduna", type: "State University" },
  { name: "Kano State University of Science and Technology, Wudil", city: "Wudil", type: "State University" },
  { name: "Kebbi State University of Science and Technology, Aliero", city: "Aliero", type: "State University" },
  { name: "Kogi State University, Anyigba", city: "Anyigba", type: "State University" },
  { name: "Kwara State University, Malete", city: "Malete", type: "State University" },
  { name: "Lagos State University, Ojo", city: "Lagos", type: "State University" },
  { name: "Ladoke Akintola University of Technology, Ogbomoso", city: "Ogbomoso", type: "State University" },
  { name: "Nasarawa State University, Keffi", city: "Keffi", type: "State University" },
  { name: "Niger Delta University, Wilberforce Island", city: "Wilberforce Island", type: "State University" },
  { name: "Olabisi Onabanjo University, Ago-Iwoye", city: "Ago-Iwoye", type: "State University" },
  { name: "Ondo State University of Science and Technology, Okitipupa", city: "Okitipupa", type: "State University" },
  { name: "Osun State University, Osogbo", city: "Osogbo", type: "State University" },
  { name: "Oyo State Technical University, Ibadan", city: "Ibadan", type: "State University" },
  { name: "Plateau State University, Bokkos", city: "Bokkos", type: "State University" },
  { name: "Rivers State University, Port Harcourt", city: "Port Harcourt", type: "State University" },
  { name: "Sokoto State University, Sokoto", city: "Sokoto", type: "State University" },
  { name: "Tai Solarin University of Education, Ijagun", city: "Ijagun", type: "State University" },
  { name: "Taraba State University, Jalingo", city: "Jalingo", type: "State University" },
  { name: "Umaru Musa Yar'adua University, Katsina", city: "Katsina", type: "State University" },
  { name: "Yobe State University, Damaturu", city: "Damaturu", type: "State University" },
  { name: "Zamfara State University, Talata Mafara", city: "Talata Mafara", type: "State University" },

  // ─── Private Universities ───────────────────────────────────────────────────
  { name: "Achievers University, Owo", city: "Owo", type: "Private University" },
  { name: "Adeleke University, Ede", city: "Ede", type: "Private University" },
  { name: "Afe Babalola University, Ado Ekiti", city: "Ado Ekiti", type: "Private University" },
  { name: "African University of Science & Technology, Abuja", city: "Abuja", type: "Private University" },
  { name: "Al-Hikmah University, Ilorin", city: "Ilorin", type: "Private University" },
  { name: "Al-Qalam University, Katsina", city: "Katsina", type: "Private University" },
  { name: "American University of Nigeria, Yola", city: "Yola", type: "Private University" },
  { name: "Augustine University, Ilara-Epe", city: "Ilara-Epe", type: "Private University" },
  { name: "Babcock University, Ilishan-Remo", city: "Ilishan-Remo", type: "Private University" },
  { name: "Baze University, Abuja", city: "Abuja", type: "Private University" },
  { name: "Bell University of Technology, Ota", city: "Ota", type: "Private University" },
  { name: "Bells University of Technology, Ota", city: "Ota", type: "Private University" },
  { name: "Benson Idahosa University, Benin City", city: "Benin City", type: "Private University" },
  { name: "Bowen University, Iwo", city: "Iwo", type: "Private University" },
  { name: "Caleb University, Lagos", city: "Lagos", type: "Private University" },
  { name: "Caritas University, Enugu", city: "Enugu", type: "Private University" },
  { name: "Chrisland University, Abeokuta", city: "Abeokuta", type: "Private University" },
  { name: "Christopher University, Mowe", city: "Mowe", type: "Private University" },
  { name: "Clifford University, Owerrinta", city: "Owerrinta", type: "Private University" },
  { name: "Coal City University, Enugu", city: "Enugu", type: "Private University" },
  { name: "Covenant University, Ota", city: "Ota", type: "Private University" },
  { name: "Crawford University, Faith City, Igbesa", city: "Igbesa", type: "Private University" },
  { name: "Crescent University, Abeokuta", city: "Abeokuta", type: "Private University" },
  { name: "Dominican University, Ibadan", city: "Ibadan", type: "Private University" },
  { name: "Edwin Clark University, Kiagbodo", city: "Kiagbodo", type: "Private University" },
  { name: "Elizade University, Ilara-Mokin", city: "Ilara-Mokin", type: "Private University" },
  { name: "Evangel University, Akaeze", city: "Akaeze", type: "Private University" },
  { name: "Fountain University, Osogbo", city: "Osogbo", type: "Private University" },
  { name: "Godfrey Okoye University, Enugu", city: "Enugu", type: "Private University" },
  { name: "Gregory University, Uturu", city: "Uturu", type: "Private University" },
  { name: "Hallmark University, Ijebu-Itele", city: "Ijebu-Itele", type: "Private University" },
  { name: "Hezekiah University, Umudi", city: "Umudi", type: "Private University" },
  { name: "Igbinedion University, Okada", city: "Okada", type: "Private University" },
  { name: "Joseph Ayo Babalola University, Ikeji-Arakeji", city: "Ikeji-Arakeji", type: "Private University" },
  { name: "Kings University, Ode-Omu", city: "Ode-Omu", type: "Private University" },
  { name: "Kola Daisi University, Ibadan", city: "Ibadan", type: "Private University" },
  { name: "Kwararafa University, Wukari", city: "Wukari", type: "Private University" },
  { name: "Landmark University, Omu-Aran", city: "Omu-Aran", type: "Private University" },
  { name: "Lead City University, Ibadan", city: "Ibadan", type: "Private University" },
  { name: "Legacy University, Okija", city: "Okija", type: "Private University" },
  { name: "Madonna University, Okija", city: "Okija", type: "Private University" },
  { name: "McPherson University, Seriki Sotayo", city: "Seriki Sotayo", type: "Private University" },
  { name: "Michael and Cecilia Ibru University, Agbarha-Otor", city: "Agbarha-Otor", type: "Private University" },
  { name: "Mountain Top University, Makogi-Oba", city: "Makogi-Oba", type: "Private University" },
  { name: "Nile University of Nigeria, Abuja", city: "Abuja", type: "Private University" },
  { name: "Novena University, Ogume", city: "Ogume", type: "Private University" },
  { name: "Obong University, Obong Ntak", city: "Obong Ntak", type: "Private University" },
  { name: "Oduduwa University, Ipetumodu", city: "Ipetumodu", type: "Private University" },
  { name: "Pan-Atlantic University, Lagos", city: "Lagos", type: "Private University" },
  { name: "Paul University, Awka", city: "Awka", type: "Private University" },
  { name: "Philomath University, Kuje", city: "Kuje", type: "Private University" },
  { name: "Redeemer's University, Ede", city: "Ede", type: "Private University" },
  { name: "Renaissance University, Enugu", city: "Enugu", type: "Private University" },
  { name: "Rhema University, Obeama-Asa", city: "Obeama-Asa", type: "Private University" },
  { name: "Ritman University, Ikot Ekpene", city: "Ikot Ekpene", type: "Private University" },
  { name: "Robert Bilad University, Hadejia", city: "Hadejia", type: "Private University" },
  { name: "Salem University, Lokoja", city: "Lokoja", type: "Private University" },
  { name: "Samuel Adegboyega University, Ogwa", city: "Ogwa", type: "Private University" },
  { name: "Spiritan University, Nneochi", city: "Nneochi", type: "Private University" },
  { name: "Summit University, Offa", city: "Offa", type: "Private University" },
  { name: "Tansian University, Umunya", city: "Umunya", type: "Private University" },
  { name: "Trinity University, Yaba", city: "Lagos", type: "Private University" },
  { name: "University of Mkar, Mkar", city: "Mkar", type: "Private University" },
  { name: "Veritas University, Abuja", city: "Abuja", type: "Private University" },
  { name: "Wesley University, Ondo", city: "Ondo", type: "Private University" },
  { name: "Western Delta University, Oghara", city: "Oghara", type: "Private University" },
  { name: "Wellspring University, Evbuobanosa", city: "Evbuobanosa", type: "Private University" },

  // ─── Federal Polytechnics ───────────────────────────────────────────────────
  { name: "Auchi Polytechnic, Auchi", city: "Auchi", type: "Federal Polytechnic" },
  { name: "Federal Polytechnic, Ado Ekiti", city: "Ado Ekiti", type: "Federal Polytechnic" },
  { name: "Federal Polytechnic, Bauchi", city: "Bauchi", type: "Federal Polytechnic" },
  { name: "Federal Polytechnic, Bida", city: "Bida", type: "Federal Polytechnic" },
  { name: "Federal Polytechnic, Daura", city: "Daura", type: "Federal Polytechnic" },
  { name: "Federal Polytechnic, Ede", city: "Ede", type: "Federal Polytechnic" },
  { name: "Federal Polytechnic, Idah", city: "Idah", type: "Federal Polytechnic" },
  { name: "Federal Polytechnic, Ilaro", city: "Ilaro", type: "Federal Polytechnic" },
  { name: "Federal Polytechnic, Kaura Namoda", city: "Kaura Namoda", type: "Federal Polytechnic" },
  { name: "Federal Polytechnic, Mubi", city: "Mubi", type: "Federal Polytechnic" },
  { name: "Federal Polytechnic, Nasarawa", city: "Nasarawa", type: "Federal Polytechnic" },
  { name: "Federal Polytechnic, Nekede", city: "Nekede", type: "Federal Polytechnic" },
  { name: "Federal Polytechnic, Offa", city: "Offa", type: "Federal Polytechnic" },
  { name: "Federal Polytechnic, Oko", city: "Oko", type: "Federal Polytechnic" },
  { name: "Federal Polytechnic, Ukana", city: "Ukana", type: "Federal Polytechnic" },
  { name: "Kaduna Polytechnic, Kaduna", city: "Kaduna", type: "Federal Polytechnic" },
  { name: "Petroleum Training Institute, Effurun", city: "Effurun", type: "Federal Polytechnic" },
  { name: "Yaba College of Technology, Lagos", city: "Lagos", type: "Federal Polytechnic" },

  // ─── State Polytechnics ─────────────────────────────────────────────────────
  { name: "Akwa Ibom State Polytechnic, Ikot Osurua", city: "Ikot Osurua", type: "State Polytechnic" },
  { name: "Delta State Polytechnic, Ogwashi-Uku", city: "Ogwashi-Uku", type: "State Polytechnic" },
  { name: "Delta State Polytechnic, Otefe-Oghara", city: "Oghara", type: "State Polytechnic" },
  { name: "Delta State Polytechnic, Ozoro", city: "Ozoro", type: "State Polytechnic" },
  { name: "Gateway ICT Polytechnic, Saapade", city: "Saapade", type: "State Polytechnic" },
  { name: "Imo State Polytechnic, Umuagwo", city: "Umuagwo", type: "State Polytechnic" },
  { name: "Kano State Polytechnic, Kano", city: "Kano", type: "State Polytechnic" },
  { name: "Kwara State Polytechnic, Ilorin", city: "Ilorin", type: "State Polytechnic" },
  { name: "Lagos State Polytechnic, Ikorodu", city: "Lagos", type: "State Polytechnic" },
  { name: "Moshood Abiola Polytechnic, Abeokuta", city: "Abeokuta", type: "State Polytechnic" },
  { name: "Nuhu Bamalli Polytechnic, Zaria", city: "Zaria", type: "State Polytechnic" },
  { name: "Osun State College of Technology, Esa-Oke", city: "Esa-Oke", type: "State Polytechnic" },
  { name: "Rufus Giwa Polytechnic, Owo", city: "Owo", type: "State Polytechnic" },
  { name: "The Polytechnic, Ibadan", city: "Ibadan", type: "State Polytechnic" },
  { name: "The Polytechnic, Kaduna", city: "Kaduna", type: "State Polytechnic" },

  // ─── Colleges of Education ──────────────────────────────────────────────────
  { name: "Adeniran Ogunsanya College of Education, Lagos", city: "Lagos", type: "College of Education" },
  { name: "Adeyemi Federal University of Education, Ondo", city: "Ondo", type: "College of Education" },
  { name: "Air Force Institute of Technology, Kaduna", city: "Kaduna", type: "College of Education" },
  { name: "Akwa Ibom State College of Education, Afaha Nsit", city: "Afaha Nsit", type: "College of Education" },
  { name: "Alvan Ikoku Federal College of Education, Owerri", city: "Owerri", type: "College of Education" },
  { name: "Anambra State College of Education, Awka", city: "Awka", type: "College of Education" },
  { name: "Bauchi State College of Education, Azare", city: "Azare", type: "College of Education" },
  { name: "College of Education, Agbor", city: "Agbor", type: "College of Education" },
  { name: "College of Education, Ekiadolor", city: "Ekiadolor", type: "College of Education" },
  { name: "College of Education, Gindiri", city: "Gindiri", type: "College of Education" },
  { name: "College of Education, Ilorin", city: "Ilorin", type: "College of Education" },
  { name: "College of Education, Kankia", city: "Kankia", type: "College of Education" },
  { name: "College of Education, Maru", city: "Maru", type: "College of Education" },
  { name: "College of Education, Zing", city: "Zing", type: "College of Education" },
  { name: "Cross River State College of Education, Akamkpa", city: "Akamkpa", type: "College of Education" },
  { name: "Emmanuel Alayande College of Education, Oyo", city: "Oyo", type: "College of Education" },
  { name: "Federal College of Education (Special), Oyo", city: "Oyo", type: "College of Education" },
  { name: "Federal College of Education, Abeokuta", city: "Abeokuta", type: "College of Education" },
  { name: "Federal College of Education, Eha-Amufu", city: "Eha-Amufu", type: "College of Education" },
  { name: "Federal College of Education, Gombe", city: "Gombe", type: "College of Education" },
  { name: "Federal College of Education, Kano", city: "Kano", type: "College of Education" },
  { name: "Federal College of Education, Katsina", city: "Katsina", type: "College of Education" },
  { name: "Federal College of Education, Kontagora", city: "Kontagora", type: "College of Education" },
  { name: "Federal College of Education, Obudu", city: "Obudu", type: "College of Education" },
  { name: "Federal College of Education, Okene", city: "Okene", type: "College of Education" },
  { name: "Federal College of Education, Pankshin", city: "Pankshin", type: "College of Education" },
  { name: "Federal College of Education, Yola", city: "Yola", type: "College of Education" },
  { name: "Federal College of Education, Zaria", city: "Zaria", type: "College of Education" },
  { name: "Gombe State College of Education, Billiri", city: "Billiri", type: "College of Education" },
  { name: "Imo State College of Education, Ihitte/Uboma", city: "Ihitte/Uboma", type: "College of Education" },
  { name: "Jigawa State College of Education, Gumel", city: "Gumel", type: "College of Education" },
  { name: "Kaduna State College of Education, Gidan Waya", city: "Gidan Waya", type: "College of Education" },
  { name: "Kebbi State College of Education, Argungu", city: "Argungu", type: "College of Education" },
  { name: "Kogi State College of Education, Ankpa", city: "Ankpa", type: "College of Education" },
  { name: "Kwara State College of Education, Ilorin", city: "Ilorin", type: "College of Education" },
  { name: "Nassarawa State College of Education, Akwanga", city: "Akwanga", type: "College of Education" },
  { name: "Niger State College of Education, Minna", city: "Minna", type: "College of Education" },
  { name: "Nwafor Orizu College of Education, Nsugbe", city: "Nsugbe", type: "College of Education" },
  { name: "Ondo State College of Education, Ilesa", city: "Ilesa", type: "College of Education" },
  { name: "Osun State College of Education, Ilesa", city: "Ilesa", type: "College of Education" },
  { name: "Oyo State College of Education, Lanlate", city: "Lanlate", type: "College of Education" },
  { name: "Plateau State College of Education, Gindiri", city: "Gindiri", type: "College of Education" },
  { name: "Rivers State College of Education, Port Harcourt", city: "Port Harcourt", type: "College of Education" },
  { name: "Shehu Shagari College of Education, Sokoto", city: "Sokoto", type: "College of Education" },
  { name: "Sokoto State College of Education, Sokoto", city: "Sokoto", type: "College of Education" },
  { name: "Tai Solarin College of Education, Ijebu-Ode", city: "Ijebu-Ode", type: "College of Education" },
  { name: "Zamfara State College of Education, Maru", city: "Maru", type: "College of Education" },
];

// Grouped by type for <optgroup> rendering
export const INSTITUTION_TYPES = [
  "Federal University",
  "State University",
  "Private University",
  "Federal Polytechnic",
  "State Polytechnic",
  "College of Education",
];

export const DEGREE_OPTIONS = [
  { value: "bsc",   label: "B.Sc (Bachelor's Degree)" },
  { value: "bedu",  label: "B.Edu (Bachelor in Education)" },
  { value: "msc",   label: "M.Sc (Master's Degree)" },
  { value: "phd",   label: "Ph.D" },
  { value: "hnd",   label: "HND (Higher National Diploma)" },
  { value: "ond",   label: "OND (Ordinary National Diploma)" },
  { value: "nce",   label: "NCE (Nigeria Certificate in Education)" },
  { value: "pgde",  label: "PGDE (Postgraduate Diploma in Education)" },
  { value: "other", label: "Other" },
];

export const getInstitutionsByType = (type) =>
  NIGERIAN_INSTITUTIONS.filter((i) => i.type === type);

export const searchInstitutions = (query) => {
  if (!query || query.trim().length < 2) return [];
  const q = query.toLowerCase();
  return NIGERIAN_INSTITUTIONS.filter((i) =>
    i.name.toLowerCase().includes(q) || i.city.toLowerCase().includes(q)
  ).slice(0, 20);
};

export const FIELD_OF_STUDY_GROUPS = [
  {
    group: "Sciences",
    fields: [
      "Biology",
      "Biochemistry",
      "Botany",
      "Chemistry",
      "Environmental Science",
      "Geology",
      "Geophysics",
      "Industrial Chemistry",
      "Marine Biology",
      "Mathematics",
      "Microbiology",
      "Physics",
      "Statistics",
      "Zoology",
    ],
  },
  {
    group: "Engineering & Technology",
    fields: [
      "Aerospace Engineering",
      "Agricultural Engineering",
      "Chemical Engineering",
      "Civil Engineering",
      "Computer Engineering",
      "Electrical / Electronics Engineering",
      "Mechanical Engineering",
      "Mechatronics Engineering",
      "Petroleum Engineering",
      "Software Engineering",
      "Systems Engineering",
      "Telecommunications Engineering",
    ],
  },
  {
    group: "Computing & IT",
    fields: [
      "Computer Science",
      "Cyber Security",
      "Data Science",
      "Information Technology",
      "Information Systems",
      "Artificial Intelligence",
      "Software Development",
    ],
  },
  {
    group: "Medicine & Health Sciences",
    fields: [
      "Dentistry",
      "Medicine & Surgery (MBBS)",
      "Medical Laboratory Science",
      "Nursing Science",
      "Optometry",
      "Pharmacy",
      "Physiotherapy",
      "Public Health",
      "Radiography",
      "Veterinary Medicine",
    ],
  },
  {
    group: "Education",
    fields: [
      "Adult Education",
      "Educational Administration",
      "Educational Psychology",
      "Guidance & Counselling",
      "Science Education",
      "Mathematics Education",
      "English Education",
      "Computer Education",
      "Business Education",
      "Technical Education",
      "Physical & Health Education",
      "Early Childhood Education",
    ],
  },
  {
    group: "Arts & Humanities",
    fields: [
      "Arabic Studies",
      "Christian Religious Studies",
      "English Language & Literature",
      "Fine & Applied Arts",
      "French",
      "History & International Studies",
      "Islamic Studies",
      "Linguistics",
      "Music",
      "Philosophy",
      "Theatre Arts",
      "Yoruba / Hausa / Igbo Studies",
    ],
  },
  {
    group: "Social Sciences",
    fields: [
      "Criminology & Security Studies",
      "Development Studies",
      "Economics",
      "Geography",
      "International Relations",
      "Mass Communication",
      "Political Science",
      "Psychology",
      "Public Administration",
      "Sociology",
      "Social Work",
    ],
  },
  {
    group: "Business & Management",
    fields: [
      "Accounting",
      "Actuarial Science",
      "Banking & Finance",
      "Business Administration",
      "Business Management",
      "Entrepreneurship",
      "Finance",
      "Human Resource Management",
      "Insurance",
      "Marketing",
      "Supply Chain & Logistics",
    ],
  },
  {
    group: "Law",
    fields: [
      "Law (LLB)",
      "International Law",
      "Islamic Law",
      "Commercial Law",
    ],
  },
  {
    group: "Agriculture & Environment",
    fields: [
      "Agricultural Economics",
      "Agricultural Science",
      "Animal Science",
      "Crop Science",
      "Fisheries & Aquaculture",
      "Food Science & Technology",
      "Forestry & Wildlife",
      "Soil Science",
    ],
  },
  {
    group: "Architecture & Built Environment",
    fields: [
      "Architecture",
      "Building Technology",
      "Estate Management",
      "Quantity Surveying",
      "Urban & Regional Planning",
    ],
  },
];
